module.exports = __webpack_public_path__ + "static/full02-5cbad044a58579d145810b698cd33c07.png";